






















































































































































































































import { Component, Vue} from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import { getDropDownStatusList, PlanHeader } from '@/entity/Ppe/PlanHeader';
import { PPE_PRODUCT_TYPE, PPE_STATUS } from '@/services/Enums';
import { GetDropdownCountriesForUser } from '@/services/PpeDropDowns';
import { saveAs } from 'file-saver';

@Component({
    components: {
        SearchFilter,
    },
})
export default class MerchandisingReport extends Vue {        
    idPlanDetail: any = null;
    numericIdSelected: number = null;
    productsType: number = null;

    showLoading: boolean = false;
    ready: boolean = false;
    planDetailEditMode: boolean = false;
    downloadReportInProgress: boolean = false;

    // advanced search
    resultsItems: any = {
        resultPage: new Array<PlanHeader>(),
        total: 0
    };
    page: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    filterSelected: boolean = false;
    advNumericId: number = null;
    advTitle: string = null;
    advNumber: string = null;
    advCountry: string = null;
    advYear: string = null;
    advStatus: string = null;

    dropDownCountries: any = new Array();  
    dropDownCountriesSubsidiary: any = new Array();
    dropDownStatus: any = new Array(); 
    
    productsTypeEnum: any = PPE_PRODUCT_TYPE;

    async mounted() {
        this.dropDownStatus = getDropDownStatusList();
        this.dropDownStatus = this.dropDownStatus.filter(x => x.value >= PPE_STATUS.IN_PROGRESS || x.value == null)
        this.dropDownCountries = await GetDropdownCountriesForUser();
        this.dropDownCountriesSubsidiary = await GetDropdownCountriesForUser(true);
        
        this.ready = true;
    }

    checkFilterParameter(){
        if(this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    get AdvancedSearchFilled(): boolean {      
        return this.CheckAdvancedSearchFilled();
    }

    CheckAdvancedSearchFilled(): boolean {
        if (!this.CheckIsNullOrEmpty(this.advCountry)) return true;     
        if (!this.CheckIsNullOrEmpty(this.advNumber)) return true;
        if (!this.CheckIsNullOrEmpty(this.advNumericId)) return true;
        if (!this.CheckIsNullOrEmpty(this.advStatus)) return true;
        if (!this.CheckIsNullOrEmpty(this.advTitle)) return true;
        if (!this.CheckIsNullOrEmpty(this.advYear)) return true;
        return false;
    }

    CheckSearchFilled() {
        if(!this.CheckIsNullOrEmpty(this.freeText)) return true;
        if(this.CheckAdvancedSearchFilled()) return true;
        return false;     
    }

    resetFilters() {
        this.advCountry = null;
        this.advNumber = null;
        this.advNumericId = null;
        this.advStatus = null;
        this.advTitle = null;
        this.advYear = null;
        this.filterSelected = false;
    }
    
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null) 
            this.freeText = genericSearch;
        
        this.searchItems(true)
    }

    searchFilterResertEvent() {
        this.resetFilters()
    }

    searchItems(start: boolean) {
        this.searchPlansDo(start);
    }

    async searchPlansDo(start: boolean) {
        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/ppe/GetMerchandisingReport'),
                data: {
                    FreeText: this.freeText,
                    NumericId: this.advNumericId,
                    Title: this.advTitle,
                    Number: this.advNumber,
                    IdCountryFrom: this.advCountry,
                    Status: this.advStatus,
                    Year: this.advYear,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'json'
            });
           
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
            this.resultsItems.extraInfo = results.data.extraInfo;

            this.firstSearch = true;
            this.page += 1;
            
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }
    }

    async downloadExcelReport() {
        this.ready = false;
        this.downloadReportInProgress = true;
        try {
            let response = await axios({
                method: 'post',
                url: General.GetApiUrl("/api/ppe/DownloadMerchandisingReport"),
                data: {
                    FreeText: this.freeText,
                    NumericId: this.advNumericId,
                    Title: this.advTitle,
                    Number: this.advNumber,
                    IdCountryFrom: this.advCountry,
                    Status: this.advStatus,
                    Year: this.advYear,
                    CurrentPage: this.page - 1
                },
                withCredentials: true,
                responseType: 'blob'
            });
            let fileName = General.getFileNameFromHeader(response.headers);
            saveAs(new Blob([response.data]), fileName);                
        } catch (error) {
            General.showAlertDanger(error, this);
        } finally {
            this.ready = true;
            this.downloadReportInProgress = false;
        }
    }

    openPlanDetail(planNumbericId: number) {
        let completeUrl = '/ppes/' + planNumbericId
        window.open(completeUrl, "_blank")
    }
}
